import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { motion } from 'framer-motion';
import { fadeInUp } from '@/motion/variants';

// Demo data for freight sensitivity
const freightData = [
  { route: 'Brazil → NOLA', rate: 45, sensitivity: 'High', impact: 8.5 },
  { route: 'Vietnam → Rotterdam', rate: 38, sensitivity: 'Medium', impact: 6.2 },
  { route: 'Indonesia → Malaysia', rate: 12, sensitivity: 'Low', impact: 2.1 },
  { route: 'Argentina → China', rate: 52, sensitivity: 'High', impact: 9.8 },
  { route: 'Thailand → Europe', rate: 35, sensitivity: 'Medium', impact: 5.5 },
  { route: 'Brazil → China', rate: 48, sensitivity: 'High', impact: 7.9 }
];

const FreightCard = () => {
  return (
    <motion.div
      variants={fadeInUp}
      initial="initial"
      animate="animate"
      className="bg-card/50 border border-border/50 p-6 rounded-lg shadow-sm"
    >
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-slate-900 mb-1">
          Freight Sensitivity Snapshot
        </h3>
        <p className="text-sm text-slate-600">
          Route-based freight rate analysis
        </p>
        <p className="text-xs text-slate-500 mt-1">
          Illustrative data - Market conditions
        </p>
      </div>

      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={freightData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
            <XAxis
              dataKey="route"
              tick={{ fontSize: 10, fill: '#64748b' }}
              axisLine={false}
              tickLine={false}
              angle={-45}
              textAnchor="end"
              height={80}
            />
            <YAxis
              tick={{ fontSize: 12, fill: '#64748b' }}
              axisLine={false}
              tickLine={false}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'white',
                border: '1px solid #e2e8f0',
                borderRadius: '6px',
                fontSize: '12px'
              }}
              formatter={(value, name) => [
                name === 'rate' ? `$${value}/MT` : `${value}%`,
                name === 'rate' ? 'Freight Rate' : 'Price Impact'
              ]}
            />
            <Bar
              dataKey="rate"
              fill="#f59e0b"
              radius={[2, 2, 0, 0]}
              name="rate"
            />
            <Bar
              dataKey="impact"
              fill="#ef4444"
              radius={[2, 2, 0, 0]}
              name="impact"
            />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="mt-4 text-xs text-slate-500">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-amber-500 rounded"></div>
            <span>Freight Rate (USD/MT)</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-red-500 rounded"></div>
            <span>Price Impact (%)</span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default FreightCard;
